<template>
  <div class="page">
    <div class="item-title">
      房源信息
    </div>
    <div class="item-line"></div>
    <div>
      <div class="div-2 div-2-top">
        <div class="div-2-title">所属区域：</div>
        <el-input disabled v-model="dataInfo.areaName"></el-input>
      </div>
      <div class="div-2 div-2-top">
        <div class="div-2-title">房号：</div>
        <el-input disabled v-model="dataInfo.houseName"></el-input>
      </div>
    </div>

    <div class="item-title">
      租赁信息
    </div>
    <div class="item-line"></div>
    <div>
      <div class="div-2 div-2-top">
        <div class="div-2-title">开始日期：</div>
        <el-date-picker
          disabled
          style="width: 100%"
          v-model="leaseStart"
          type="date"
        >
        </el-date-picker>
      </div>
      <div class="div-2 div-2-top">
        <div class="div-2-title">结束日期：</div>
        <el-date-picker
          disabled
          style="width: 100%"
          v-model="leaseEnd"
          type="date"
        >
        </el-date-picker>
      </div>
      <div class="div-2 div-2-top">
        <div class="div-2-title">总期数：</div>
        <el-input disabled v-model="dataInfo.totalUnits"></el-input>
      </div>
      <div class="div-2 div-2-top">
        <div class="div-2-title">付租方式：</div>
        <el-input disabled v-model="dataInfo.unit"></el-input>
      </div>
    </div>

    <div class="item-title">
      承租人
    </div>
    <div class="item-line"></div>
    <div>
      <div class="div-2 div-2-top">
        <div class="div-2-title">姓名：</div>
        <el-input disabled v-model="dataInfo.renters[0].renterName"></el-input>
      </div>
      <div class="div-2 div-2-top">
        <div class="div-2-title">手机：</div>
        <el-input disabled v-model="dataInfo.renters[0].renterPhone"></el-input>
      </div>
      <div class="div-2 div-2-top">
        <div class="div-2-title">证件类型：</div>
        <el-input disabled v-model="dataInfo.renters[0].cardType"></el-input>
      </div>
      <div class="div-2 div-2-top">
        <div class="div-2-title">证件号码：</div>
        <el-input disabled v-model="dataInfo.renters[0].cardNum"></el-input>
      </div>
    </div>

    <div class="item-title">
      收费信息
    </div>
    <div class="item-line"></div>
    <el-table :data="pricings">
      <el-table-column prop="name" label="项目名称" align="center">
      </el-table-column>
      <el-table-column label="详情" align="center" min-width="180">
        <template slot-scope="scope">
          <div style="width: 100%">
            <div class="div-2">
              <div class="div-2-title">价格:</div>
              <div class="div-2-content">{{ scope.row.amountStr }}</div>
            </div>
            <div class="div-2">
              <div class="div-2-title">总期数:</div>
              <div class="div-2-content">{{ scope.row.totalUnits }}</div>
            </div>
            <div class="div-2">
              <div class="div-2-title">已付期数:</div>
              <div class="div-2-content">{{ scope.row.paidUnits }}</div>
            </div>
            <div class="div-2">
              <div class="div-2-title">付费方式:</div>
              <div class="div-2-content">{{ scope.row.isPostPayStr }}</div>
            </div>
            <div class="div-2">
              <div class="div-2-title">备注:</div>
              <div class="div-2-content">{{ scope.row.comment }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="item-title">
      关联人员
    </div>
    <div class="item-line"></div>
    <el-table :data="otherRenters">
      <el-table-column prop="renterName" label="姓名" align="center">
      </el-table-column>
      <el-table-column prop="renterPhone" label="手机" align="center" min-width="180">
      </el-table-column>
    </el-table>

    <!--    <div style="margin-top: 20px">-->
    <!--      <el-button type="primary" plain size="medium" @click="submit"-->
    <!--        >一键缴费</el-button-->
    <!--      >-->
    <!--    </div>-->
  </div>
</template>

<script>
import axios from "axios";
import { Loading } from "element-ui";
import Utils from "../../Utils";
import wx from "weixin-js-sdk";
import mixins from "../../minix";

export default {
  name: "home",
  mixins: [mixins],

  data() {
    return {
      dataInfo: {},
      pricings: [],
      otherRenters: [], // 除承租人以外的其它租客
    };
  },

  computed: {
    leaseStart() {
      return new Date(this.dataInfo.leaseStart * 1000);
    },

    leaseEnd() {
      return new Date(this.dataInfo.leaseEnd * 1000);
    },

    leaseTotalStr() {
      return `${this.dataInfo.totalUnits}${this.dataInfo.unit}`;
    }
  },

  created() {
    Utils.userInfo.leaseID = this.$route.query.leaseID;
    Utils.userInfo.client = this.$route.query.client;

    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", this.$route.query.client || "");

    this.query();

    document.title = "合同详情";
  },

  methods: {
    submit() {
      // 微信小程序
      wx.miniProgram.getEnv(function() {
        wx.miniProgram.navigateTo({
          url:
            "/pages/bills/bills?" +
            "leaseID=" +
            Utils.userInfo.leaseID +
            "&state=1"
        });
      });
    },

    //查询信息
    query() {
      let data = {
        leaseID: Utils.userInfo.leaseID
      };

      const loading = Loading.service({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });

      let url = axios.defaults.baseURL + "leases/detail";
      url = url.replace("org", "users");
      url = url.replace("10241", "10242");

      axios({
        method: "post",
        url: url,
        data: data
      })
        .then(value => {
          if (value.data.data) {
            this.dataInfo = value.data.data;
            this.pricings = [];
            this.otherRenters = [];
            if (Array.isArray(this.dataInfo.pricings)) {
              this.dataInfo.pricings.forEach(item => {
                item.amountStr = this.numFormat(item.amount / 100) + "元/" + item.unit;
                if (item.name === "电费" || item.name === "水费") {
                  item.amountStr = this.meterPricing(item.amount / 10000) + "元/" + item.unit;
                }
                item.isPostPayStr = item.isPostPay ? "后付费" : "预付费";
                item.paidUnitsStr = item.paidUnits + "/" + item.totalUnits;
                this.pricings.push(item);
              });
              for(let i=0; i<this.dataInfo.renters.length; i++) {
                if (i > 0) {
                  this.otherRenters.push(this.dataInfo.renters[i])
                }
              }
            }
          }
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.log(err);
        })
        .finally(() => {
          loading.close();
          // this.pricings.push({
          //   name: "测试",
          //   amountStr: "110元/吨",
          //   isPostPayStr: "后付费",
          //   paidUnitsStr: "1/12",
          //   comment: ""
          // });
        });
    }
  }
};
</script>

<style>
.el-select .el-input {
  min-width: 80px;
}
.input-with-select {
  background-color: #fff;
}
.el-tag + .el-tag {
  margin-top: 10px;
  margin-left: 10px;
}
.button-new-tag {
  margin-top: 10px;
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>

<style lang="scss">
@import "../../style.css";

.item-title {
  text-align: start;
  font-size: 18px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.item-main {
  box-sizing: border-box;
  margin-top: 10px;
  margin-bottom: 20px;
}
.item-line {
  width: 100%;
  height: 1px;
  background: #f2f2f2;
}
.header {
  margin-top: 80px;
  justify-content: space-around;
}
.header-title {
  text-align: right;
  width: 150px;
}
</style>
